import React from 'react';
import classnames from 'classnames';

import styles from './index.css';

const getTransformValue = (direction, size) => {
	let translateX = 0;
	let translateY = 0;
	let rotate = 0;

	if (direction === 'left') {
		translateX = size / 6;
		rotate = 225;
	} else if (direction === 'right') {
		translateX = size / 6 * -1;
		rotate = 45;
	} else if (direction === 'up') {
		translateY = size / 6;
		rotate = 315;
	} else {
		translateY = size / 6 * -1;
		rotate = 135;
	}

	return `translate(${translateX}px, ${translateY}px) rotate(${rotate}deg)`;
};

const Triangle = ({ direction = 'right', color, size = 10, borderWidth, className }) => (
	<span
		className={classnames(styles.triangle, className, {
			[styles.left]: direction === 'left',
			[styles.right]: direction === 'right',
			[styles.up]: direction === 'up',
			[styles.down]: direction === 'down',
		})}
		style={{
			width: `${size}px`,
			height: `${size}px`,
			borderColor: color || '#2D2926',
			borderWidth: borderWidth ? `${borderWidth}px ${borderWidth}px 0 0` : '2px 2px 0 0',
			transformOrigin: 'center',
			transform: getTransformValue(direction, size),
		}}
	/>
);

export default Triangle;



// WEBPACK FOOTER //
// ./src/components/atoms/Triangle/index.js